import React from 'react'
import styled from 'styled-components'
import { mixinInputFormClasses } from 'spa/member/styles/mixin'
import { useFormContext, Controller } from 'react-hook-form'
import { FormErrorMessage } from '../FormErrorMessage'

export type Props = {
  name: string
  options: OptionType[]
  rules?: any
  inputSize?: 'default' | 'small'
} & React.SelectHTMLAttributes<HTMLSelectElement>

export type OptionType = {
  label: string
  value: string
}

const StyledSelectContainer = styled.div<{ inputSize?: 'default' | 'small'}>`
  position: relative;

  &::after {
    font-family: 'Material Symbols Outlined';
    content: '\\e313';
    position: absolute;
    top: ${props => props.inputSize === 'small' ? 'calc(50% - 9.5px)' : 'calc(50% - .75rem)'};
    right: 12px;
    color: var(--color-member-gray-100);
    pointer-events: none;
    font-size: 1rem;
    line-height: ${props => props.inputSize === 'small' ? '21px' : '1.5'};
  }
`

export const StyledSelect: React.FC<Props> = props => {
  const { control, formState: { errors } } = useFormContext()

  const hasError = !!errors[props.name]

  const baseClassName = 'appearance-none bg-member-white-100 text-member-black-100'
  const className = [baseClassName, props.className || '', mixinInputFormClasses(hasError, props.inputSize)].filter(Boolean).join(' ')

  return (
    <div>
      <Controller
        name={props.name}
        control={control}
        rules={props.rules}
        render={({ field }) => (
          <>
            <StyledSelectContainer inputSize={props.inputSize || 'default'}>
              <select
                {...field}
                {...Object.fromEntries(Object.entries(props).filter(([key, _value]) => !['options', 'rules', 'inputSize'].includes(key)))}
                className={className}
                onChange={e => {
                  field.onChange(e);
                  props.onChange && props.onChange(e)}}
              >
                {props.options.map((option: OptionType, index) => (
                  <option key={index} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </StyledSelectContainer>
            {hasError && <FormErrorMessage message={String(errors[props.name]?.message)} />}
          </>
        )}
      />
    </div>
  )
}
